<template>
  <div class="container">
    <a-form-model
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="项目名称" prop="project_id" ref="project_id">
        <a-select
          style="width:300px"
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
          v-model="ruleForm.project_id"
          @change="onSelectedPro"
          placeholder="请选择项目"
        >
          <a-select-option
            v-for="(item, i) in proList"
            :key="i"
            :value="item.id"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="出库网点" prop="device_ids" ref="device_ids">
        <a-select
          showSearch
          mode="multiple"
          style="width:300px"
          :filterOption="filterOption"
          optionFilterProp="children"
          placeholder="请选择网点设备"
          v-model="ruleForm.device_ids"
          @change="handleChange"
        >
          <a-select-option
            v-for="(item, i) in deviceList"
            :key="i"
            :value="item.device_id"
            >{{ item.device_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <div class="trackingList" v-for="(item, key) in trackingList" :key="key">
        <label><i>*</i>{{ item.name + "：" }}</label>
        <a-input
          style="width:200px"
          v-model="item.num"
          placeholder="请输入物流单号"
        />
      </div>
      <a-form-model-item label="出库日期" prop="out_date">
        <a-date-picker v-model="ruleForm.out_date" />
      </a-form-model-item>
      <a-form-model-item label="出库类型" prop="out_type">
        <a-radio-group v-model="ruleForm.out_type">
          <a-radio :value="1">
            补货
          </a-radio>
          <a-radio :value="2">
            美陈
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="出库货品" prop="pass">
        <table class="goodsList">
          <thead>
            <th>商品名称</th>
            <th>商品图</th>
            <th>现存数量</th>
            <th>出库数量</th>
          </thead>
          <tbody>
            <tr
              v-show="warehouseMaterialList != ''"
              v-for="(item, key) in warehouseMaterialList"
              :key="key"
            >
              <td>{{ item.brand_name }}</td>
              <td>
                <img :src="item.imageUrl.url_thumb" alt="" />
              </td>
              <td>{{ item.real_inventory }}</td>
              <td>
                <a-input-number
                  v-model="item.number"
                  :max="item.real_inventory"
                  :min="1"
                />
              </td>
            </tr>
            <tr v-show="warehouseMaterialList == ''" class="noData">
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </a-form-model-item>
      <a-form-model-item> </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 12, offset: 5 }">
        <a-button style="margin-right: 10px" @click="resetForm('ruleForm')">
          重置
        </a-button>
        <a-button type="primary" @click="submitForm('ruleForm')">
          提交
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      moment,
      labelCol: { span: 5 },
      wrapperCol: { span: 12 },
      ruleForm: {
        project_id: "",
        device_ids: [],
        out_date: "",
        out_type: "",
        material_list: []
      },
      rules: {
        project_id: [
          { required: true, message: "请选择项目", trigger: "change" }
        ],
        device_ids: [
          { required: true, message: "请选择出库网点", trigger: "change" }
        ],
        out_date: [
          { required: true, message: "请选择出库日期", trigger: "change" }
        ],
        out_type: [
          { required: true, message: "请选择出库类型", trigger: "change" }
        ]
      },
      proList: [],
      deviceList: [],
      warehouseMaterialList: [],
      trackingList: []
    };
  },
  mounted() {
    this.getPro(); //获取项目
  },
  methods: {
    handleChange(val) {
      // console.log(val);
      this.trackingList = [];
      this.deviceList.forEach(item => {
        if (val.indexOf(item.device_id) >= 0) {
          this.trackingList.push({
            id: item.device_id,
            name: item.device_name,
            num: ""
          });
        }
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onSelectedPro(id) {
      this.getDeviceList(id); //获取设备列表
      this.getWarehouseMaterialList(id); //获取总仓物料
    },
    getDeviceList(id) {
      this.ruleForm.device_ids = [];
      let url =
        this.httpsBasic.url + this.httpsBasic.equipment + "Device/getListData";
      let params = {
        project_id: id,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.deviceList = res.data.data;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getWarehouseMaterialList(id) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Project_material/getListData";
      let params = {
        project_id: id,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.warehouseMaterialList = res.data.data;
          // console.log(this.warehouseMaterialList);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          current_page: 1,
          per_page: 10000,
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 2
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    verification() {
      let fls = true;
      this.trackingList.forEach(item => {
        // console.log(item);
        if (item.num == "") {
          this.$message.warning("请输入物流单号！");
          fls = false;
          return fls;
        }
      });
      return fls;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        let fls = this.verification();
        if (valid && fls) {
          let device_ids = [];
          this.trackingList.forEach(item => {
            device_ids.push({
              device_id: item.id,
              express: item.num
            });
          });
          let url =
            this.httpsBasic.url +
            this.httpsBasic.equipment +
            "Project_material/out";
          // console.log(this.warehouseMaterialList);
          this.ruleForm.material_list = [];
          if (this.warehouseMaterialList != "") {
            this.warehouseMaterialList.forEach(element => {
              if (element.number != undefined) {
                this.ruleForm.material_list.push({
                  project_material_id: element.project_material_id,
                  number: element.number
                });
              }
            });
          }
          let params = {
            token: window.localStorage.getItem("xnwfPcToken"),
            out_date: moment(this.ruleForm.out_date).format("YYYY-MM-DD"),
            out_type: this.ruleForm.out_type,
            device_ids: JSON.stringify(device_ids),
            material_list: JSON.stringify(this.ruleForm.material_list)
          };
          // console.log(params);
          axios.post(url, params).then(res => {
            if (res.data.code == 200) {
              this.$emit("hideInOut", true);
              this.$refs[formName].resetFields();
              this.$message.success("提交成功");
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  margin-top: 50px;
  .goodsList {
    td,
    th {
      border: 1px solid #ccc;
      padding: 4px 6px;
      font-size: 12px;
      line-height: 20px;
      img {
        width: 50px;
        height: 50px;
        object-fit: cover;
      }
    }
    .noData {
      border: 1px solid #ccc;
      td {
        border: none;
      }
    }
  }
  .trackingList {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0 0 20px 13%;
    > label {
      width: 24%;
    }
    i {
      display: inline-block;
      font-style: normal;
      color: red;
      margin-right: 6px;
    }
  }
}
</style>
